import api from './api';
import {
  HelpRequest,
  HelpRequestMessage,
  MessageReaction,
  CreateHelpRequestInput,
  HelpRequestStats,
} from '../types/help-request.types';

export const helpRequestService = {
  async create(
    sessionId: string,
    data: CreateHelpRequestInput,
  ): Promise<HelpRequest> {
    const response = await api.post(
      `/sessions/${sessionId}/help-requests`,
      data,
    );
    return response.data;
  },

  async getBySession(sessionId: string): Promise<HelpRequest[]> {
    const response = await api.get(`/sessions/${sessionId}/help-requests`);
    return response.data;
  },

  async getMessages(helpRequestId: string): Promise<HelpRequestMessage[]> {
    const response = await api.get(`/help-requests/${helpRequestId}/messages`);
    return response.data;
  },

  async addMessage(helpRequestId: string, message: string): Promise<HelpRequestMessage> {
    const response = await api.post(`/help-requests/${helpRequestId}/messages`, { message });
    return response.data;
  },

  async resolve(id: string, response?: string): Promise<HelpRequest> {
    const resp = await api.patch(`/help-requests/${id}/resolve`, response ? { response } : {});
    return resp.data;
  },

  async getStats(sessionId: string): Promise<HelpRequestStats> {
    const response = await api.get(
      `/sessions/${sessionId}/help-requests/stats`,
    );
    return response.data;
  },

  async addReaction(requestId: string, messageId: string, emoji: string): Promise<MessageReaction[]> {
    const response = await api.post(
      `/help-requests/${requestId}/messages/${messageId}/reactions`,
      { emoji },
    );
    return response.data;
  },

  async removeReaction(requestId: string, messageId: string, emoji: string): Promise<MessageReaction[]> {
    const response = await api.delete(
      `/help-requests/${requestId}/messages/${messageId}/reactions/${encodeURIComponent(emoji)}`,
    );
    return response.data;
  },
};
